import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { MyProvider } from './Context/MyContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import colors from './Config/colors';

const root_el = document.documentElement; // :root

// Map colors.js keys  →  CSS variable names
const varMap = {
  // Green brand
  primary:          '--color-primary',
  primary_dark:     '--color-primary-dark',
  primary_light:    '--color-primary-light',
  primary_xlight:   '--color-primary-xlight',
  primary_bg:       '--color-primary-bg',
  primary_border:   '--color-primary-border',
  primary_glow:     '--color-primary-glow',

  // Derived from primary (rgba variants — computed here)
  // These are hardcoded as rgba strings in colors.js already

  // Form (Navy / Gold)
  form_primary:     '--color-form-primary',
  form_primary_l:   '--color-form-primary-l',
  form_accent:      '--color-form-accent',
  form_accent_l:    '--color-form-accent-l',

  // Neutral
  white:            '--color-white',
  bg:               '--color-bg',
  bg_form:          '--color-bg-form',
  bg_input:         '--color-bg-input',
  bg_card:          '--color-bg-card',
  border:           '--color-border',
  border_light:     '--color-border-light',

  // Text
  text:             '--color-text',
  text_sub:         '--color-text-sub',
  text_placeholder: '--color-text-placeholder',
  text_label:       '--color-text-label',

  // Semantic
  error:            '--color-error',
  success:          '--color-success',
  warning:          '--color-warning',
  info:             '--color-info',

  // Dark surfaces
  dark_bg:          '--color-dark-bg',
  dark_footer:      '--color-dark-footer',
  dark_card:        '--color-dark-card',
  dark_overlay:     '--color-dark-overlay',

  // YouTube
  youtube_red:      '--color-youtube',

  // Ad / OTP
  ad_overlay:       '--color-ad-overlay',
  otp_focus_glow:   '--color-primary-focus',
};

// Set all CSS variables on :root
Object.entries(varMap).forEach(([key, cssVar]) => {
  if (colors[key] !== undefined) {
    root_el.style.setProperty(cssVar, colors[key]);
  }
});

// Extra derived variables not in varMap
root_el.style.setProperty('--color-primary-pulse',  'rgba(200, 160, 74, 0.70)');
root_el.style.setProperty('--color-info-bg',         '#eff6ff');
root_el.style.setProperty('--color-info-border',     '#bfdbfe');
root_el.style.setProperty('--color-youtube-dark',    '#cc0000');
root_el.style.setProperty('--color-backdrop',        'rgba(0, 0, 0, 0.50)');

// ── Render ─────────────────────────────────────────────────
const rootEl = ReactDOM.createRoot(document.getElementById('root'));
rootEl.render(
  <React.StrictMode>
    <BrowserRouter>
      <MyProvider>
        <App />
      </MyProvider>
    </BrowserRouter>
  </React.StrictMode>
);